function onDomLoad(eventFunction) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', eventFunction);
  } else {
    // `DOMContentLoaded` already fired
    eventFunction();
  }
}

// onDomLoad(() => {
//   console.log('hi?');

//   document.body.classList.add('dom-loaded');
// });

// remove shopify coookie banner on localhost - will show on every relaod otherwhise
(() => {
  if (window.location.hostname !== '127.0.0.1') return;

  const style = document.createElement('style');
  style.innerHTML = `
    /* Add your custom styles here */
    #shopify-pc__banner {
      display: none!important;
    }
    body {
      cursor: default!important;
    }
    `;
  // .popup-modal {
  //   display: none!important;
  // }
  document.head.appendChild(style);
})();
